import $ from "jquery";

// materialize-css...
window.$ = $;
window.jQuery = $;
